enum SourcePointConsent {
	AcceptAll = 11,
	RejectAll = 13,
}

export function giveSourcepointConsent(doConsent: boolean) {
	const event = new MessageEvent("message", {
		data: {
			name: "sp.hideMessage",
			fromPM: true,
			actionType: doConsent ? SourcePointConsent.AcceptAll : SourcePointConsent.RejectAll,
		},
		origin: "https://cdn.privacy-mgmt.com",
	});

	window.dispatchEvent(event);
}
